var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-overlay-asset-custom-overlay-fields"},_vm._l((_vm.collagePresets),function(preset){return _c('div',{key:preset.id},[_c('collage-custom-overlay-fields',{attrs:{"preset":preset}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }